import React, { useState } from 'react';
import { FiLock, FiShield } from 'react-icons/fi';
import StaffLayout from './StaffLayout';
import StaffAuthenticatorAccount from './StaffAuthenticatorAccount';
import { useInternalStaff } from './InternalStaffRoute';
import { staffJSON } from './staffApi';

export function StaffAccountSettings() {
  const staff = useInternalStaff();
  const [mfaStatus, setMfaStatus] = useState(null);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const changePassword = async event => {
    event.preventDefault();
    if (busy || !mfaStatus) return;
    setError(''); setMessage('');
    if (newPassword !== confirmation) { setError('The new passwords do not match.'); return; }
    setBusy(true);
    try {
      const result = await staffJSON('/account/password', { method: 'POST', body: JSON.stringify({ currentPassword, newPassword, ...(mfaStatus.totp_enabled ? { code } : {}) }) });
      setCurrentPassword(''); setNewPassword(''); setConfirmation(''); setCode(''); setMessage(result.message);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  return <div className="staff-settings-grid">
    <section className="staff-panel" aria-label="Password settings">
      <h2><FiLock />Change password</h2>
      <p>Update the password for your staff account, {staff?.email}.</p>
      <form className="staff-mfa-form" onSubmit={changePassword}>
        <label>Current password<input type="password" autoComplete="current-password" value={currentPassword} onChange={event => setCurrentPassword(event.target.value)} required disabled={busy} /></label>
        <label>New password<input type="password" autoComplete="new-password" minLength={12} maxLength={72} value={newPassword} onChange={event => setNewPassword(event.target.value)} required disabled={busy} /></label>
        <small>Use at least 12 characters. Passwords may contain up to 72 UTF-8 bytes.</small>
        <label>Confirm new password<input type="password" autoComplete="new-password" minLength={12} maxLength={72} value={confirmation} onChange={event => setConfirmation(event.target.value)} required disabled={busy} /></label>
        {mfaStatus?.totp_enabled && <><label>App or recovery code<input autoComplete="one-time-code" aria-describedby="staff-password-factor-help" value={code} maxLength={40} onChange={event => setCode(event.target.value)} required disabled={busy} /></label><small id="staff-password-factor-help">Use a fresh app code or an unused recovery code to confirm this change.</small></>}
        {error && <p role="alert" className="staff-inline-error">{error}</p>}
        {message && <p role="status" className="staff-inline-success">{message}</p>}
        <div className="staff-actions"><button type="submit" className="staff-primary" disabled={busy || !mfaStatus}>{busy ? 'Updating password...' : 'Change password'}</button></div>
      </form>
    </section>
    <section className="staff-panel" aria-label="Authenticator settings">
      <h2><FiShield />Authenticator app</h2>
      <StaffAuthenticatorAccount required={Boolean(staff?.mfa_setup_prompt)} onStatusChange={setMfaStatus} onComplete={staff?.completeMfaSetup} />
    </section>
  </div>;
}

export default function StaffSettingsPage() {
  return <StaffLayout section="settings" showSetupBanner={false}><StaffAccountSettings /></StaffLayout>;
}
